import { InjectionToken } from '@angular/core';

export const WindowToken: InjectionToken<Window> = new InjectionToken<Window>('Window');

export function windowProvider() {
    return window;
}
